import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a href='https://github.com/Saraesabbagh' className='link footer__link'>
      Created By Sara Sabbagh
    </a>
  </footer>
)

export default Footer
